(function () {
  var states = new WeakMap();
  var pendingEscapeRoot = null;

  function getState(root) {
    if (!states.has(root)) {
      states.set(root, { stack: ['root'], origins: [], scroll: new Map() });
    }
    return states.get(root);
  }

  function setPanel(root, panelId) {
    root.querySelectorAll('[data-drv-accessories-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-drv-accessories-panel') === panelId;
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      panel.classList.toggle('is-active', active);
    });
  }

  function getScrollContainer(panel) {
    if (!panel) return null;
    var localScroller = panel.querySelector('[data-drv-accessories-scroll]');
    if (localScroller && localScroller.scrollHeight > localScroller.clientHeight) return localScroller;
    if (typeof panel.closest === 'function') {
      return panel.closest('.drawer__scrollable') || localScroller;
    }
    return localScroller;
  }

  function openPanel(root, trigger) {
    var targetId = trigger.getAttribute('data-drv-accessories-open');
    var target = root.querySelector('[data-drv-accessories-panel="' + targetId + '"]');
    if (!target) return false;

    var state = getState(root);
    var currentId = state.stack[state.stack.length - 1];
    var current = root.querySelector('[data-drv-accessories-panel="' + currentId + '"]');
    var scroller = getScrollContainer(current);
    state.scroll.set(currentId, scroller ? scroller.scrollTop : 0);
    state.origins.push(trigger);
    state.stack.push(targetId);
    trigger.setAttribute('aria-expanded', 'true');
    setPanel(root, targetId);

    var back = target.querySelector('[data-drv-accessories-back]');
    if (back) back.focus();
    return true;
  }

  function goBack(root) {
    var state = getState(root);
    if (state.stack.length <= 1) return false;

    state.stack.pop();
    var origin = state.origins.pop();
    var panelId = state.stack[state.stack.length - 1];
    setPanel(root, panelId);

    var panel = root.querySelector('[data-drv-accessories-panel="' + panelId + '"]');
    var scroller = getScrollContainer(panel);
    if (scroller) scroller.scrollTop = state.scroll.get(panelId) || 0;
    if (origin) {
      origin.setAttribute('aria-expanded', 'false');
      origin.focus();
    }
    return true;
  }

  function reset(root) {
    var state = getState(root);
    state.stack.length = 1;
    state.stack[0] = 'root';
    state.origins.length = 0;
    state.scroll.clear();
    if (pendingEscapeRoot === root) pendingEscapeRoot = null;
    setPanel(root, 'root');
    root.querySelectorAll('[data-drv-accessories-open][aria-expanded]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('[data-drv-accessories-panel]').forEach(function (panel) {
      var scroller = getScrollContainer(panel);
      if (scroller) scroller.scrollTop = 0;
    });
  }

  function getAccessoriesDrilldown(details) {
    if (!details || details.tagName !== 'DETAILS' || typeof details.querySelector !== 'function') return null;
    var drawer = details.querySelector('[data-drv-accessories-drawer]');
    if (!drawer || typeof drawer.querySelector !== 'function') return null;
    return drawer.querySelector('[data-drv-accessories-drilldown]');
  }

  function closeDrawer(root) {
    var drawer = root.closest('#MenuDrawer') || document.querySelector('#MenuDrawer');
    if (!drawer) return false;

    var controls = Array.prototype.slice.call(
      drawer.querySelectorAll('button[aria-controls="MenuDrawer"][aria-label]')
    );
    var closeControl = controls.find(function (control) {
      if (control.hidden) return false;
      if (typeof control.getClientRects === 'function') return control.getClientRects().length > 0;
      return control.offsetParent !== null;
    }) || controls[0];
    if (!closeControl || typeof closeControl.click !== 'function') return false;

    closeControl.click();
    return true;
  }

  function handleClick(event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var trigger = event.target.closest('[data-drv-accessories-open]');
    if (trigger) {
      var openRoot = trigger.closest('[data-drv-accessories-drilldown]');
      if (openRoot && openPanel(openRoot, trigger)) event.preventDefault();
      return;
    }

    var back = event.target.closest('[data-drv-accessories-back]');
    if (!back) return;
    var backRoot = back.closest('[data-drv-accessories-drilldown]');
    if (backRoot && goBack(backRoot)) event.preventDefault();
  }

  function handleKeydown(event) {
    if (event.key !== 'Escape' || !event.target || typeof event.target.closest !== 'function') return;

    var drilldown = event.target.closest('[data-drv-accessories-drilldown]');
    if (drilldown) {
      var handled = goBack(drilldown) || closeDrawer(drilldown);
      if (!handled) return;
      pendingEscapeRoot = drilldown;
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var panel = event.target.closest('[data-drv-accessories-mega]');
    if (!panel) return;

    var details = panel.closest('details');
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;

    var summary = details.querySelector(':scope > summary[aria-label="Accessories"]');
    if (!summary) return;

    event.preventDefault();
    event.stopPropagation();
    details.open = false;
    summary.focus();
  }

  function handleKeyup(event) {
    if (event.key !== 'Escape' || !pendingEscapeRoot || !event.target || typeof event.target.closest !== 'function') return;
    if (event.target.closest('[data-drv-accessories-drilldown]') !== pendingEscapeRoot) return;
    pendingEscapeRoot = null;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function handleToggle(event) {
    var details = event.target;
    if (!details || details.open) return;
    var drilldown = getAccessoriesDrilldown(details);
    if (drilldown) reset(drilldown);
  }

  function handleDrawerAfterHide(event) {
    var scope = event.target && typeof event.target.querySelectorAll === 'function'
      ? event.target
      : document;
    scope.querySelectorAll('[data-drv-accessories-drilldown]').forEach(function (root) {
      reset(root);
      var details = root.closest('details');
      if (details && details.tagName === 'DETAILS') details.open = false;
    });
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('keydown', handleKeydown, true);
  document.addEventListener('keyup', handleKeyup, true);
  document.addEventListener('toggle', handleToggle, true);
  document.addEventListener('drawer:afterHide', handleDrawerAfterHide);
})();
